export default __webpack_public_path__ + "static/media/top_review_bg.37853c8a.png";